import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import moment from 'moment';

class AdminDB extends Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
  }

  render() {
    return (
      <div className="animated fadeIn" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
        <h4>Truy cập vào <a href="http://houselink.xuongapp.com:3333/nodeadmin/" target="_blank">AdminDB Nodejs</a> </h4>
        <h4>Truy cập vào <a href="http://houselink.xuongapp.com/phpmyadmin/" target="_blank">phpMyAdmin</a> </h4>
        <p>user: <strong>root</strong></p>
        <p>pass: <strong>9WJUOTNQ020v</strong></p>
        <p style={{color: "red"}}>NOTE: Hết sức cẩn thận khi tương tác trực tiếp với database</p>
      </div>
    );
  }
}

export default AdminDB;


// WEBPACK FOOTER //
// ./src/views/Dashboard/AdminDB.js